import React, { useState, useCallback, useEffect } from 'react';
import DropdownUI from '@/pages/datalab/components/DropdownUI';
import FilterPanel from '@/pages/datalab/components/UserFilter/FilterPanel';
import { IFilterPanelDropdownProps, IUserGroup } from '@/pages/datalab/components/UserFilter/FilterPanel/type';

import './index.scss';

const FilterPanelDropdown: React.FC<IFilterPanelDropdownProps> = ({
  value,
  fieldOption = [],
  stringDataMap = {},
  preNode,
  nextNode,
  button,
  dropdownProps,
  onConfirm,
  onCancel,
  getStringData,
  children, 
  onOpenClose,
  ...rest
}) => {
  const { open: controlledOpen, onOpenChange: controlledOnOpenChange, ...restDropdownProps } = dropdownProps || {};
  const [currentValue, setCurrentValue] = useState<IUserGroup | undefined>(value);
  const [internalOpen, setInternalOpen] = useState<boolean>(false);

  // 当外部 value 变化时更新内部状态
  useEffect(() => {
    if (value) {
      setCurrentValue(value);
    }
  }, [JSON.stringify(value)]);

  // 如果 dropdownProps 中有 open，使用受控模式；否则使用内部状态
  const isControlled = controlledOpen !== undefined;
  const open = isControlled ? controlledOpen : internalOpen;

  const handleOpenChange = useCallback(
    (newOpen: boolean) => {
      onOpenClose?.(newOpen);
      if (controlledOnOpenChange) {
        controlledOnOpenChange(newOpen);
      } else if (!isControlled) {
        setInternalOpen(newOpen);
      }
      if (!newOpen) {
        onCancel?.();
      }
    },
    [controlledOnOpenChange, onCancel, isControlled]
  );

  const handleConfirm = useCallback((value: IUserGroup) => {
    onConfirm?.(value);
    if (!isControlled) {
      setInternalOpen(false);
    }
  }, [onConfirm, isControlled]);

  const handleCancel = useCallback(() => {
    onCancel?.();
    if (!isControlled) {
      setInternalOpen(false);
    }
  }, [onCancel, isControlled]);

  return (
    <DropdownUI
      className="dbl-filter-panel-dropdown"
      boxClassName="dbl-filter-panel-box"
      placement="bottom-start"
      button={button || currentValue?.name}
      open={open}
      clickClose={false}
      onOpenChange={handleOpenChange}
      haveButton={false}
      {...restDropdownProps}
      {...rest}
    >
      <FilterPanel
        value={currentValue}
        fieldOption={fieldOption}
        stringDataMap={stringDataMap}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
        getStringData={getStringData}
        {...rest}
      />
    </DropdownUI>
  );
};

export default FilterPanelDropdown;

